<script lang="ts" setup>
import type { NuxtError } from '#app'

interface Props {
  error: NuxtError
}

defineProps<Props>()

useAppProvides()
</script>

<template>
  <CommonErrorPage :error="error" />
</template>
